if (typeof ProductQuantity !== "function") {
  function initializeProductQuantity() {
    class ProductQuantity extends HTMLElement {
      constructor() {
        super();

        const qty = this.querySelector(".qty-selector"),
          qtyMinus = this.querySelector(".qty-minus"),
          qtyPlus = this.querySelector(".qty-plus"),
          qtyMin = qty.getAttribute("min")
            ? parseInt(qty.getAttribute("min"))
            : 5,
          qtyMax = qty.getAttribute("max")
            ? parseInt(qty.getAttribute("max"))
            : 999;

        if (parseInt(qty.value) - 5 < qtyMin) {
          qtyMinus.classList.add("disabled");
        }
        if (parseInt(qty.value) + 5 > qtyMax) {
          qtyPlus.classList.add("disabled");
        }

        qty.addEventListener("change", (e) => {
          const currentQty = parseInt(qty.value);
          if (parseInt(qty.value) - 5 < qtyMin) {
            qtyMinus.classList.add("disabled");
          } else {
            qtyMinus.classList.remove("disabled");
          }
          if (parseInt(qty.value) + 5 > qtyMax) {
            qtyPlus.classList.add("disabled");
          } else {
            qtyPlus.classList.remove("disabled");
          }
        });

        qtyMinus.addEventListener("click", (e) => {
          e.preventDefault();
          if (!qtyMinus.classList.contains("disabled")) {
            const currentQty = parseInt(qty.value);
            if (currentQty - 5 >= qtyMin) {
              qty.value = currentQty - 5;
              qtyPlus.classList.remove("disabled");
            }

            if (currentQty - 5 <= qtyMin) {
              qtyMinus.classList.add("disabled");
            }
          }
        });

        qtyPlus.addEventListener("click", (e) => {
          e.preventDefault();
          if (!qtyPlus.classList.contains("disabled")) {
            const currentQty = parseInt(qty.value);
            const max = qty.getAttribute("max");
            if (currentQty + 5 <= max) {
              qty.value = currentQty + 5;
              qtyMinus.classList.remove("disabled");
            }

            if (currentQty + 10 >= max) {
              qtyPlus.classList.add("disabled");
            }
          }
        });
      }
    }

    if (typeof customElements.get("product-quantity") == "undefined") {
      customElements.define("product-quantity", ProductQuantity);
    }
  }

  // Initialize on page load
  initializeProductQuantity();

  // Reinitialize when new products are added
  document.addEventListener("infiniteScroll:productsAdded", () => {
    initializeProductQuantity();
  });
}
